import React from "react";

import { Button, Link, Profile } from "@stellar/design-system";

interface Step2FundAccountProps {
  distributionAccountPublicKey: string;
  onNext: () => void;
  onSkip: () => void;
}

export const Step2FundAccount: React.FC<Step2FundAccountProps> = ({
  distributionAccountPublicKey,
  onNext,
  onSkip,
}) => (
  <div className="Onboarding__card">
    <p className="Onboarding__cardTitle">Fund your distribution account</p>
    <p className="Onboarding__cardDescription">
      Add USDC to your account to start sending payments.
    </p>

    {distributionAccountPublicKey && (
      <div className="Onboarding__publicKey">
        <Profile publicAddress={distributionAccountPublicKey} size="md" isCopy hideAvatar />
      </div>
    )}

    <div className="Onboarding__messagesContainer">
      <p>
        Copy and paste this public key into your preferred exchange or wallet to fund your account.
        You don&apos;t need to include a memo for this transaction.
      </p>
      <p>
        Fund this account when you&apos;re ready to send payments. Team members with disbursement
        permissions can send payments from this account.
      </p>
    </div>

    <div className="Onboarding__actions">
      <Button isFullWidth={true} variant="primary" size="lg" onClick={onNext}>
        Next
      </Button>
      <Link role="button" size="md" variant="secondary" onClick={onSkip}>
        Fund the account later
      </Link>
    </div>
  </div>
);
